import React from 'react';
import styleable from 'react-styleable';
import PropTypes from 'prop-types';
import '../../styles/core.scss';
import css from './available-students-filter.scss';
import StudentList from '../../components/student-list/student-list';
import Checkbox from '../../components/checkbox/checkbox';
import DropdownSelect from '../dropdown-select/dropdown-select';
import { findItemWithIndex } from '../../helpers/utils';
import Text from './available-students-filter-text';


const AvailableStudentsFilter = ({
    allSelected,
    classGroupId,
    classGroups,
    classrooms,
    selectAll,
    selectClass,
    selectGroup,
    selectStudents,
    selectSurname,
    selectYearGroup,
    selectedClassId,
    students,
    surnameId,
    surnames,
    yearGroups,
    yearGroupId,
    productId
}) => {
    const selectedSurname = findItemWithIndex(surnames, 'id', surnameId);
    const selectedYearGroup = findItemWithIndex(yearGroups, 'id', yearGroupId);

    const selectedClassroom = findItemWithIndex(classrooms, 'id', selectedClassId);
    const selectedClassGroup = findItemWithIndex(classGroups, 'id', classGroupId);

    return (
        <div className={css['available-students-filter']}>
            <div className={`${css['sub-header']} page-subheader`}>
                <div className={css['select-holder']}>
                    <DropdownSelect
                        rawData={surnames}
                        labelProperty="name"
                        selectedIndex={selectedSurname.indexValue}
                        onChange={(item) => {
                            selectSurname(productId, (item || {}).id, selectedClassId, classGroupId, yearGroupId);
                        }} />
                </div>
                <div className={css['select-holder']}>
                    <DropdownSelect
                        rawData={yearGroups}
                        labelProperty="name"
                        selectedIndex={selectedYearGroup.indexValue}
                        onChange={(item) => {
                            selectYearGroup(productId, (item || {}).id, selectedClassId, classGroupId, surnameId);
                        }} />
                </div>
            </div>
            <div className={`${css['sub-header']} page-subheader`}>
                <div className={css['select-holder']}>
                    <DropdownSelect
                        rawData={classrooms}
                        labelProperty="name"
                        selectedIndex={selectedClassroom.indexValue}
                        onChange={(item) => {
                            selectClass(productId, (item || {}).id, surnameId, yearGroupId);
                        }} />
                </div>
                <div className={css['select-holder']}>
                    <DropdownSelect
                        rawData={classGroups}
                        labelProperty="name"
                        selectedIndex={selectedClassGroup.indexValue}
                        onChange={(item) => {
                            selectGroup((item || {}).id);
                        }} />
                </div>
                {students.length !== 0 ?
                    <Checkbox
                        data={{ type: 'plain', selected: allSelected, label: Text.selectAll }}
                        callback={originalData =>
                            selectAll(!originalData.selected)}
                    /> : null
                }
            </div>
            <div className={css['student-list']}>
                <StudentList
                    students={students}
                    onChange={selectStudents}
                    type={Text.noStudentsAvailable}
                />
            </div>
        </div>
    );
};

/**
 * Define the type of properties that can be set on this component
 */
AvailableStudentsFilter.propTypes = {
    surnames: PropTypes.array,
    yearGroups: PropTypes.array,
    classrooms: PropTypes.array,
    selectedClassId: PropTypes.any,
    classGroups: PropTypes.array,
    classGroupId: PropTypes.any,
    selectAll: PropTypes.func,
    selectSurname: PropTypes.func,
    selectYearGroup: PropTypes.func,
    selectClass: PropTypes.func,
    selectGroup: PropTypes.func,
    students: PropTypes.array,
    selectStudents: PropTypes.func,
    allSelected: PropTypes.bool,
    surnameId: PropTypes.string,
    yearGroupId: PropTypes.number,
    productId: PropTypes.any
};

export default styleable(css)(AvailableStudentsFilter);



// WEBPACK FOOTER //
// ./components/available-students-filter/available-students-filter.js